import React, { useCallback, useEffect } from "react";

const TextField = ({ fieldId, label, relatedOption, defaultAnswer, handleChange }) => {
  // Para generar el campo adicional de texto, al iniciar el componente, se gatilla un nuevo evento onchange que "modifica" el campo de texto, eso permite que la función de
  // utilidad cree el campo en el objeto y permita realizar validaciones al cambiar la página
  const initializeIntoAnswers = useCallback(() => {
    const input = document.getElementById(fieldId);
    var nativeInputValueSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    ).set;

    nativeInputValueSetter.call(input, "");
    var event = new Event("input", { bubbles: true });
    input.dispatchEvent(event);
  }, []);

  useEffect(() => {
    if (!defaultAnswer) {
      initializeIntoAnswers();
    }
  }, [initializeIntoAnswers]);

  return (
    <div>
      {label ?? "Especifique."}
      <input
        id={fieldId}
        className="form-control mb-2"
        name={relatedOption}
        type="text"
        value={defaultAnswer ?? " "}
        onChange={handleChange}
      />
    </div>
  );
};

export default TextField;
